import { render, staticRenderFns } from "./PettyCash.vue?vue&type=template&id=c2a54240&"
import script from "./PettyCash.vue?vue&type=script&lang=js&"
export * from "./PettyCash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports